import { FAQS } from "../seo/routing";

/* Visible FAQ accordion (native <details>, so it is keyboard-accessible and
   its text is always in the DOM for crawlers). Schema is emitted by applySeo. */
export default function FaqSection({ faqKey }) {
  const items = FAQS[faqKey];
  if (!items || !items.length) return null;
  return (
    <section className="faq-sec" aria-labelledby="faq-heading">
      <div className="faq-wrap">
        <span className="faq-tag"><i />FAQs</span>
        <h2 id="faq-heading" className="faq-title">Frequently Asked <em>Questions</em></h2>
        <div className="faq-list">
          {items.map((f) => (
            <details className="faq-item" key={f.q}>
              <summary><span>{f.q}</span><b aria-hidden="true" /></summary>
              <p>{f.a}</p>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}
